import { Dispatch, SetStateAction, useCallback, useState } from 'react'

export const useSelect = <T extends string>(
  initialState: T,
  unions: T[] = []
): {
  state: T
  handleState: (value: T) => void
  setState: Dispatch<SetStateAction<T>>
} => {
  type Unions = (typeof unions)[number]
  const [state, setState] = useState<T>(initialState)
  const isMatchedUnion = (value: string): value is Unions => {
    // unionsが指定されていなければただのstring型
    if (unions.length === 0) {
      return true
    } else {
      return unions.some((v) => v === value)
    }
  }
  const handleState = useCallback(
    (value: T) => {
      if (!isMatchedUnion(value)) return
      setState(value)
    },
    [setState, unions]
  )
  return { state, handleState, setState }
}

export default useSelect
